module.exports = __webpack_public_path__ + "img/dianji.2ab7237b.png";